import React from 'react'
import './styles/CustomCalendar.css'
import { months } from '../constants/dateTime';
import { eventTypeColors } from '../constants/colors';
import { types } from '../constants/eventVars';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export default function CustomCalendar({ handleMonthChange, filtersSelected, year, displayMonth, currentMonth, dayOfMonth, eventsData, openModal }) {

    const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const firstDayIndex = (new Date(year, displayMonth, 1).getDay() + 6) % 7; // Adjust so Monday = 0
    const daysInPrevMonth = new Date(year, displayMonth, 0).getDate();
    const daysInMonth = new Date(year, displayMonth + 1, 0).getDate();

    const isCurrentMonth = displayMonth === currentMonth;

    function getEventsOnDate(dayOfMonth) {
        const componentsToRender = []
        if (eventsData[dayOfMonth]?.length > 0) {
            eventsData[dayOfMonth].forEach((eventObj, index) => {
                const eventType = eventObj.badge === "yes" ? 'temp' : (types.includes(eventObj?.type) ? eventObj?.type : 'other')
                if (filtersSelected.includes(eventType) || eventType === 'other' || eventType === "temp") {
                    componentsToRender.push(
                        <div onClick={() => openModal('event', { eventData: { ...eventObj } })} key={index}
                            style={{ borderLeftColor: eventTypeColors[eventType].mid }}
                            className={'event-calendar-card'}>
                            <p className='calendar-event-title'>{eventObj.title}</p>
                        </div>)
                }
            })
        }
        return (
            componentsToRender
        )
    }


    return (
        <div className='calendar-container'>
            <div className='calendar-header-container'>
                <div className='calendar-header-title'>
                    <span className={`calendar-header-month${isCurrentMonth ? ' current' : ''}`}>{months[displayMonth]}</span>
                    <span className='calendar-header-year'>{year}</span>
                </div>
                <div className='calendar-header-nav'>
                    <button type='button' className='calendar-nav-btn' onClick={() => handleMonthChange('back')} aria-label='Previous month'>
                        <ArrowBackIosNewIcon sx={{ fontSize: '13px' }} />
                    </button>
                    <button type='button' className='calendar-nav-btn' onClick={() => handleMonthChange('forward')} aria-label='Next month'>
                        <ArrowForwardIosIcon sx={{ fontSize: '13px' }} />
                    </button>
                </div>
            </div>
            <div className='calendar-body-container'>
                <div className='calendar-weekday-container'>
                    {daysOfWeek.map((day) => {
                        return (<p key={day} className='weekday-title'>{day}</p>)
                    })}
                </div>
                <div className='calendar-days-container'>
                    {Array.from({ length: firstDayIndex }).map((_, i) => (
                        <div key={`pre-${i}`} className="day-block out-of-month">
                            <p className='day-number'>
                                {daysInPrevMonth - (firstDayIndex - 1 - i)}
                            </p>
                        </div>
                    ))}
                    {Array.from({ length: daysInMonth }).map((_, i) => {
                        const isToday = dayOfMonth === (i + 1) && isCurrentMonth;
                        return (
                            <div key={i} className={`day-block${isToday ? ' today' : ''}`}>
                                <p className='day-number'>
                                    {i + 1}
                                </p>
                                <div className='day-block-event-section'>
                                    {getEventsOnDate(i + 1)}
                                </div>
                            </div>
                        );
                    })}
                    {Array.from({ length: 42 - firstDayIndex - daysInMonth }).map((_, i) => (
                        <div key={`post-${i}`} className="day-block out-of-month">
                            <p className='day-number'>
                                {i + 1}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
